import { t } from 'ttag';
import withDrawerLayout from '../withDrawerLayout';
import '../style.scss';

/**
 * Reference drawer listing the selectable ethnicity options with the official description of each, from African or African American through North African. Defines the option array inline and renders each title with its description, wrapped by withDrawerLayout for the shared drawer chrome.
 *
 * @returns The ethnicity reference list rendered inside the drawer layout.
 */
const EthnicityDrawer = withDrawerLayout(() => {
  const ethnicityOptions = [
    {
      title: t`${t`African`} or ${t`African American`}`,
      description: t`A person having origins in any of the black racial groups of Africa. Terms such as "Haitian" or "Negro" can be used in addition to "African or African American."`,
    },
    {
      title: t`American Indian or Alaska Native`,
      description: t`A person having origins in any of the original peoples of North and South America (including Central America), and who maintains tribal affiliation or community attachment.`,
    },
    {
      title: t`Asian`,
      description: t`A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.`,
    },
    {
      title: t`Caucasian`,
      description: t`A person having origins in any of the original peoples of Europe.`,
    },
    {
      title: t`Hispanic or Latino`,
      description: t`A person of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race. The term, "Spanish origin," can be used in addition to "Hispanic or Latino."`,
    },
    {
      title: t`Middle Eastern`,
      description: t`A person having origins from the Middle East.`,
    },
    {
      title: t`Native Hawaiian or Other Pacific Islander`,
      description: t`A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.`,
    },
    {
      title: t`North African`,
      description: t`A person having origins from North Africa such as Morocco, Egypt.`,
    },
  ];

  return (
    <div className="ethnicity-list">
      {ethnicityOptions.map((item) => (
        <div key={item.title} className="ethnicity-item">
          <div className="ethnicity-item__title">{item.title}</div>
          <span className="ethnicity-item__description">{item.description}</span>
        </div>
      ))}
    </div>
  );
});

(EthnicityDrawer as any).defaultProps = {
  title: t`Ethnicity`,
  className: 'ethnicity-drawer',
};

export default EthnicityDrawer;
